import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useToast } from '@kanda-libs/ks-design-library';
import {
  type Job,
  type Service,
  actions,
  services,
  useSubmit,
} from '@kanda-libs/ks-frontend-services';

import { useAppDispatch } from 'components/shared/App';
import useReloadInitialData from 'hooks/useReloadInitialData';
import { selectors } from 'store';
import jobSelectors from 'store/selectors/job';
import { serviceConvert } from 'utils';

export interface MarkJobAsPaidButtonPropsHook {
  showContent: boolean;
  onClick: () => void;
  isSubmitting: boolean;
  isLoading: boolean;
}

export default function useMarkJobAsPaidButtonProps(): MarkJobAsPaidButtonPropsHook {
  const dispatch = useAppDispatch();
  const isLoading = useSelector(selectors.getIsLoading);
  const job = useSelector(jobSelectors.getEntity);

  const refreshAll = useReloadInitialData();

  const { showError } = useToast();

  const { submit: payout, isSubmitting = false } = useSubmit(
    serviceConvert(services.job.payoutJob),
  );

  const showContent = useMemo(() => {
    if (job?.finance_status !== 'payout_pending') return false;
    return true;
  }, [job]);

  const onClick = useCallback(() => {
    dispatch(
      actions.payoutJob({
        params: { id: job?.id as string },
        onError: () => {
          showError('Error marking job paid');
        },
      }),
    );
  }, [showError, refreshAll, payout, job]);

  return {
    showContent,
    onClick,
    isSubmitting,
    isLoading,
  };
}
